import {combineReducers} from '@reduxjs/toolkit';

import {usageReportsStateSlice} from './generated-reports/slices/usage-reports-state.slice';
import {usageReportsSlice} from './generated-reports/slices/usage-reports.slice';

export const usageReportReducer = combineReducers({
    reports: usageReportsSlice.reducer,
    state: usageReportsStateSlice.reducer,
});
